"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["classNames", "Component", "children", "className", "defaultClassName", "variant", "containerVariant", "defaultBreakPoints", "effect", "onWidthChange"],
  _excluded2 = ["breakPoints"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    componentsStyle = _useContext.componentsStyle,
    useStyle = _useContext.useStyle,
    target = _useContext.target;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? componentsStyle || defaultStyle : _props$classNames,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? 'div' : _props$Component,
    children = props.children,
    className = props.className,
    defaultClassName = props.defaultClassName,
    variant = props.variant,
    _props$containerVaria = props.containerVariant,
    containerVariant = _props$containerVaria === void 0 ? variant : _props$containerVaria,
    _props$defaultBreakPo = props.defaultBreakPoints,
    defaultBreakPoints = _props$defaultBreakPo === void 0 ? !!(containerVariant === 'root' || containerVariant === 'parent') : _props$defaultBreakPo,
    effect = props.effect,
    onWidthChange = props.onWidthChange,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var breakPoints = rest2.breakPoints,
    rest = (0, _objectWithoutProperties2["default"])(rest2, _excluded2);
  if (defaultBreakPoints && !breakPoints) {
    if (containerVariant === 'parent') {
      breakPoints = {
        1: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'xs'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'xs'
        },
        320: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'vs'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'vs'
        },
        540: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'sm'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'sm'
        },
        720: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'md'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'md'
        },
        960: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'lg'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'lg'
        },
        1040: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'xl'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'xl'
        },
        1400: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'xxl'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'xxl'
        }
      };
    } else {
      breakPoints = {
        1: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'xs'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'xs'
        },
        320: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'vs'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'vs'
        },
        576: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'sm'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'sm'
        },
        768: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'md'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'md'
        },
        992: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'lg'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'lg'
        },
        1200: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'xl'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'xl'
        },
        1440: {
          className: classNames['container-' + (containerVariant ? containerVariant + '-' : '') + 'xxl'],
          attributeName: 'vlm-container-' + (containerVariant ? containerVariant + '-' : '') + 'xxl'
        }
      };
    }
  }
  if (classNames !== componentsStyle) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var container = (0, _react.useRef)();
  var currentBreakPoint = null;
  function onResize() {
    if (container.current && breakPoints && Object.keys(breakPoints).find(function (key) {
      return breakPoints[key].attributeName || breakPoints[key].className;
    })) {
      var examE = container.current;
      if (!examE) {
        return;
      }
      var width = examE.offsetWidth;
      var breakPointsNumber = Object.keys(breakPoints);
      var foundBreakPoint = null;
      breakPointsNumber.sort(function (a, b) {
        if (isNaN(Number(a)) || isNaN(Number(a))) {
          return 0;
        }
        if (Number(a) > Number(b)) {
          return 1;
        }
        if (Number(a) < Number(b)) {
          return -1;
        }
        return 0;
      });
      breakPointsNumber.forEach(function (breakPoint) {
        if (!isNaN(Number(breakPoint)) && width >= Number(breakPoint)) {
          foundBreakPoint = breakPoint;
        }
      });
      if (foundBreakPoint && foundBreakPoint !== currentBreakPoint) {
        currentBreakPoint = foundBreakPoint;
        if (onWidthChange) {
          onWidthChange(foundBreakPoint);
        }
        var removeClassNames = breakPointsNumber.filter(function (breakPoint) {
          if (Number(breakPoint) > foundBreakPoint) {
            return true;
          }
        }).map(function (breakPoint) {
          var _breakPoints$breakPoi;
          return (_breakPoints$breakPoi = breakPoints[breakPoint]) === null || _breakPoints$breakPoi === void 0 ? void 0 : _breakPoints$breakPoi.className;
        }).filter(function (className) {
          return className;
        }).reduce(function (a, className) {
          a.push.apply(a, (0, _toConsumableArray2["default"])(className.split(' ').filter(function (t) {
            return t;
          })));
          return a;
        }, []);
        var addClassNames = breakPointsNumber.filter(function (breakPoint) {
          if (Number(breakPoint) <= foundBreakPoint) {
            return true;
          }
        }).map(function (breakPoint) {
          var _breakPoints$breakPoi2;
          return (_breakPoints$breakPoi2 = breakPoints[breakPoint]) === null || _breakPoints$breakPoi2 === void 0 ? void 0 : _breakPoints$breakPoi2.className;
        }).filter(function (className) {
          return className;
        }).reduce(function (a, className) {
          a.push.apply(a, (0, _toConsumableArray2["default"])(className.split(' ').filter(function (t) {
            return t;
          })));
          return a;
        }, []);
        if (addClassNames.length) {
          var _examE$classList;
          (_examE$classList = examE.classList).add.apply(_examE$classList, (0, _toConsumableArray2["default"])(addClassNames));
        }
        if (removeClassNames.length) {
          var _examE$classList2;
          (_examE$classList2 = examE.classList).remove.apply(_examE$classList2, (0, _toConsumableArray2["default"])(removeClassNames));
        }
        var removeAttributes = breakPointsNumber.filter(function (breakPoint) {
          if (Number(breakPoint) > foundBreakPoint) {
            return true;
          }
        }).map(function (breakPoint) {
          var _breakPoints$breakPoi3;
          return (_breakPoints$breakPoi3 = breakPoints[breakPoint]) === null || _breakPoints$breakPoi3 === void 0 ? void 0 : _breakPoints$breakPoi3.attributeName;
        }).filter(function (attributeName) {
          return attributeName;
        });
        var addAttributes = breakPointsNumber.filter(function (breakPoint) {
          if (Number(breakPoint) <= foundBreakPoint) {
            return true;
          }
        }).map(function (breakPoint) {
          var _breakPoints$breakPoi4;
          return (_breakPoints$breakPoi4 = breakPoints[breakPoint]) === null || _breakPoints$breakPoi4 === void 0 ? void 0 : _breakPoints$breakPoi4.attributeName;
        }).filter(function (attributeName) {
          return attributeName;
        });
        addAttributes.forEach(function (attributeName) {
          examE.setAttribute(attributeName, '');
        });
        removeAttributes.forEach(function (attributeName) {
          examE.removeAttribute(attributeName);
        });
      }
    }
  }
  function addResizeListeners() {
    var examE = container.current;
    if (examE && breakPoints && typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function (entries) {
        onResize(entries);
      });
      resizeObserver.observe(examE);
      return function removeEventListener() {
        resizeObserver.disconnect();
        container.removeResizeListener = null;
      };
    }
  }
  if (target === 'web') {
    (0, _react.useLayoutEffect)(function () {
      if (container.removeResizeListener) {
        container.removeResizeListener();
      }
      var examE = container.current;
      if (examE) {
        onResize();
        container.removeResizeListener = addResizeListeners();
        return container.removeResizeListener;
      }
    });
  }
  function getClassName(className) {
    return (0, _clsx["default"])(classNames.container, classNames['container-' + containerVariant], defaultClassName, className);
  }
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setClassName: function setClassName(className) {
            if (container.current) {
              container.current.className = getClassName(className);
            }
          }
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setClassName: function setClassName() {}
          }
        });
      }
    };
  });
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({
    ref: function ref(e) {
      if (container.removeResizeListener) {
        container.removeResizeListener();
      }
      container.current = e;
      var examE = container.current;
      if (examE) {
        onResize();
        container.removeResizeListener = addResizeListeners();
      }
      if (_ref) {
        if (typeof _ref === 'function') {
          _ref(e);
        } else if (_ref && typeof _ref === 'object') {
          _ref.current = e;
        }
      }
    },
    className: getClassName(className)
  }, rest), children);
});